import { Link } from 'react-router-dom';
export default function PrivacyFooter() {
  return (
    <footer className="relative py-20 bg-[#0f0f11] border-t border-[#1a1a1c]">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center space-y-8">
          <div className="flex items-center justify-center gap-4">
            <img
              src="https://static.readdy.ai/image/151e34d9a5807cd608014213251345d2/83f5e4b8fbdb9e6636dc2fdb7fe48e2c.png"
              alt="HushLegal"
              className="h-14 w-auto"
            />
            <span className="text-white text-3xl font-black">HushLegal</span>
          </div>
          <div className="space-y-4">
            <p className="text-[#a1a1aa] text-[20px]">Questions?</p>
            
              <a href="mailto:sales@hushlegal.com"
              className="inline-flex items-center gap-2 text-[#06b6d4] text-[22px] font-bold hover:text-white transition-colors cursor-pointer"
            >
              sales@hushlegal.com
            </a>
          </div>
          <div className="flex items-center justify-center gap-6 pt-8">
            <Link
              to="/"
              className="px-8 py-4 bg-[#d4af37] text-black rounded-full font-bold hover:shadow-[0_0_30px_rgba(212,175,55,0.5)] transition-all text-base cursor-pointer whitespace-nowrap"
            >
              Back to Home
            </Link>
            <Link
              to="/"
              onClick={() => {
                setTimeout(() => {
                  const el = document.getElementById('final-cta');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }, 100);
              }}
              className="px-8 py-4 bg-[#18181b] border border-[#27272a] text-white rounded-full font-bold hover:border-[#06b6d4] hover:shadow-[0_0_30px_rgba(6,182,212,0.15)] transition-all text-base cursor-pointer whitespace-nowrap"
            >
              Join Waitlist
            </Link>
          </div>
          <div className="pt-12 border-t border-[#1a1a1c]">
            <p className="text-[#52525b] text-sm">
              © 2026 HushLegal. Your privilege. Your data. Protected.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}